const WORDS = ["Serramenti", "Pavimenti", "Rivestimenti", "Rubinetteria", "Arredamento", "Scavi", "Demolizioni", "Impianti", "Chiavi in mano"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display italic font-light text-5xl md:text-7xl text-[#f4f1ea] px-8 md:px-12 whitespace-nowrap">{w}</span>
        <span className="w-2 h-2 rotate-45 bg-[#d4a73c]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee" className="relative border-y border-[#d4a73c]/15 py-10 md:py-14 overflow-hidden bg-[#0d0d0e]">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
